export function formatPhoneNumber(phoneCode: string, phoneNumber: string, spaced?: boolean): string {
  const _phoneCode = phoneCode.replace(/[^0-9]/g, "");
  const _phoneNumber = phoneNumber.replace(/[^0-9]/g, "");
  const space = spaced ? ' ' : '';
  // replace all non-numeric characters to sanitize
  return `+${_phoneCode}${space}${_phoneNumber}`
}